import { memo } from "react";
import { OrderListprops } from "../../../../Component/Interface/Order";
import { Icon } from "../../../../Component/style/common_style";
import RenderMultiRows2, {
  HeaderRow,
  Row,
  Table,
  TableHeader,
} from "../../../../Component/style/orderTable_style2";

const Order_refound = memo(({ list, modify_memo }: OrderListprops) => {
  return (
    <>
      <TableHeader $width={100} style={{ borderLeft: "1px solid #858585" }}>
        <HeaderRow>주문자</HeaderRow>
        <HeaderRow $width={6}>입금자</HeaderRow>
        <HeaderRow>주문일시</HeaderRow>
        <HeaderRow $width={6}>상품 번호</HeaderRow>
        <HeaderRow>품목명</HeaderRow>
        <HeaderRow>옵션</HeaderRow>
        <HeaderRow>단가</HeaderRow>
        <HeaderRow $width={5}>수량</HeaderRow>
        <HeaderRow>총금액</HeaderRow>
        <HeaderRow>환불일시</HeaderRow>
      </TableHeader>

      {list.map((data, idx) => {
        const rowHeight = data.order_details.length || 1;

        return (
          <Table
            key={idx}
            className={idx % 2 === 0 ? "" : "x2"}
            $width={100}
            $height={rowHeight}
          >
            <Row>{data.order_name}</Row>
            <Row $width={6}>{data.order_nickname}</Row>

            {[
              { key: "주문일시" },
              { key: "상품번호", width: 6 },
              { key: "품목명" },
              { key: "옵션" },
              { key: "단가" },
              { key: "수량", width: 5 },
            ].map(({ key, width }) => (
              <Row key={key} $width={width}>
                <RenderMultiRows2
                  detailData={data.order_details}
                  searchkey={key}
                />
              </Row>
            ))}

            {[{ key: "총 금액" }, { key: "상태변경일" }].map(({ key }) => (
              <Row key={key}>
                <RenderMultiRows2
                  detailData={data.order_details}
                  searchkey={key}
                />
              </Row>
            ))}
          </Table>
        );
      })}
    </>
  );
});

export default Order_refound;
